import { RequestBuilder, fetchAndRetryIfServerBusy } from '../utils/fetch';
import { SESSION_HEADER_EVENT_ID } from '../constants/Request';

/**
 * Client for calling into appointments
 */

export default class AppointmentsClient {
  constructor(baseURL, eventId, environment) {
    this.apptsBaseUrl = `${baseURL}appointments/`;
    if (environment) {
      this.environment = environment;
    }
    this.request = new RequestBuilder({ url: this.apptsBaseUrl })
      .withCookies()
      .header(SESSION_HEADER_EVENT_ID, eventId);
  }

  /**
   * Retrieves the appt event information
   */
  async getApptEventDetails(authToken, eventId) {
    const apptEventDetailsUrl = `${this.apptsBaseUrl}v1/registration/info/${eventId}`;
    let requestBuilder = this.request
      .url(apptEventDetailsUrl)
      .get()
      .auth(authToken);
    if (this.environment) {
      requestBuilder = requestBuilder.query('environment', this.environment);
    }
    const request = requestBuilder.build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (response.ok) {
      return await response.json();
    }
    return {};
  }

  /**
   * Retrieves the appt event info
   */
  async getApptEventInfo(authToken, eventId) {
    const apptEventDetailsUrl = `${this.apptsBaseUrl}v1/external/${eventId}`;
    let requestBuilder = this.request
      .url(apptEventDetailsUrl)
      .get()
      .auth(authToken);
    if (this.environment) {
      requestBuilder = requestBuilder.query('environment', this.environment);
    }
    const request = requestBuilder.build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (response.ok) {
      return await response.json();
    }
    return {};
  }

  /**
   * Retrieves the exhibitor custom fields
   */
  async getExhibitorCustomFields(authToken, eventId) {
    const apptEventDetailsUrl = `${this.apptsBaseUrl}v1/external/${eventId}/exhibitors/custom_fields`;
    let requestBuilder = this.request
      .url(apptEventDetailsUrl)
      .get()
      .auth(authToken);
    if (this.environment) {
      requestBuilder = requestBuilder
        .query('environment', this.environment);
    }
    const request = requestBuilder.build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (response.ok) {
      return await response.json();
    }
    return [];
  }

  /**
   * Retrieves the exhibitor list (though appointments service)
   */
  async getExhibitorsList(authToken, eventId) {
    const exhibitorListUrl = `${this.apptsBaseUrl}v1/external/${eventId}/exhibitors`;
    let requestBuilder = this.request
      .url(exhibitorListUrl)
      .get()
      .auth(authToken);
    if (this.environment) {
      requestBuilder = requestBuilder
        .query('environment', this.environment);
    }
    const request = requestBuilder.build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (response.ok) {
      return await response.json();
    }
    return [];
  }

  /**
   * Retrieves the exhibitor custom fields
   */
  async getGuestExhibitorCustomFields(authToken, eventId, customFieldIds = []) {
    const apptEventDetailsUrl = `${this.apptsBaseUrl}v1/registration/exhibitors/${eventId}/custom_fields`;
    let requestBuilder = this.request
      .url(apptEventDetailsUrl)
      .post()
      .json({ customFields: customFieldIds })
      .auth(authToken);
    if (this.environment) {
      requestBuilder = requestBuilder
        .query('environment', this.environment);
    }
    const request = requestBuilder.build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (response.ok) {
      return await response.json();
    }
    return [];
  }

  /**
   * Retrieves the exhibitor list (though appointments service)
   */
  async getGuestExhibitorsList(authToken, eventId, customFieldIds) {
    const exhibitorListUrl =
      `${this.apptsBaseUrl}v1/registration/exhibitors/${eventId}`;
    let requestBuilder = this.request
      .url(exhibitorListUrl)
      .post()
      .json({ customFields: customFieldIds })
      .auth(authToken);

    if (this.environment) {
      requestBuilder = requestBuilder
        .query('environment', this.environment);
    }
    const request = requestBuilder.build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (response.ok) {
      return await response.json();
    }
    return [];
  }
}
